import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {pollsEdit_template} from "../components/templates/pollsEdit_template";
import {PollFormatter} from "../utils/PollFormatter";

declare var ko: any;
declare var page: any;

export class polls_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected pollsEdit: pollsEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){

        return "polls_edit";
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.pollsEdit = new pollsEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Edit Poll");

        return [this.pollsEdit.build()];
    }

    public fillPage() : void{

        this.pollsEdit.buildDatePickerCalendar();
        let brandId = this.getBrandId();
        this.pollsEdit.setBrandId(brandId);

        this.getReferences();
    }

    protected getMemoryViewModel(){
        //delete templateViewModel.Job;

        return this.pollsEdit.getTemplateViewModel();
    }


    protected getReferences() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.pollsEdit.builtTemplate);

        let usrReq_url: string = `/api/polls/references`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.setReferences(responseParsed);
                obj.getData();
            });
        }
    }

    protected getData(){

        let id: number = 0;
        let pathId = this.getVnAppZone().app.params.id;
        if (pathId !== undefined && !isNaN(pathId)) {
            this.pollsEdit.setId(pathId);
            id = pathId;
        }

        this.loadingIn(this.pollsEdit.builtTemplate);

        let brandId = this.getBrandId();

        let usrReq_url: string = `/api/brand/${brandId}/polls/get/${id}`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.pollsEdit.builtTemplate);
            });
        }
    }

    protected updateList(data){

        const poll = PollFormatter.formatForEdit(data, this.getBrandId());
        this.pollsEdit.setId(poll.id);
        this.pollsEdit.setName(poll.name);
        this.pollsEdit.setDescription(poll.description);
        this.pollsEdit.setQuestions(poll.questions);
        this.pollsEdit.setSections(poll.sections);
        this.pollsEdit.setAttachedBrands(poll.brandResults);
        if (poll.idReferenceArticle) {
            this.pollsEdit.setReferenceBrandId(poll.idReferenceBrand);
            this.pollsEdit.setReferenceArticle(poll.referenceArticle);
            this.pollsEdit.setDateGeneratedFromArticle(poll.dateGeneratedFromArticle);
        }
        this.pollsEdit.setDiscussionArticle(poll.discussionArticle);
        this.pollsEdit.setDateClosed(poll.dateClosed);
    }

    protected savePoll(redirectOnSuccess: boolean = true) {

        this.loadingIn(this.pollsEdit.builtTemplate);

        let formReq_url: string = `/api/brand/0/polls/save/`;
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.pollsEdit.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    // Capture the id assigned on create so a following save updates the
                    // same poll instead of inserting a duplicate (relevant when we stay
                    // on the editor, e.g. after generating commercial signals).
                    let responseParsed = JSON.parse(req.request.response);
                    if (responseParsed && responseParsed.id) {
                        obj.pollsEdit.setId(responseParsed.id);
                    }
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Polls saved successfully !");
                    if (redirectOnSuccess) {
                        let brandId = obj.getBrandId();
                        page.redirect(`/brand/${brandId}/categorization/polls/`);
                    }
                });
                obj.loadingOut(obj.pollsEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public generateCommercialSignals() {

        let brandId = this.getBrandId();

        let formReq_url: string = `/api/brand/${brandId}/polls/generate-commercial-signals/`;
        let formReq_params: Array<Array<string>> = [];

        this.pollsEdit.setIsGeneratingCommercialSignals(true);
        this.loadingIn(this.pollsEdit.builtTemplate);

        let payload = { questions: JSON.parse(ko.toJSON(this.pollsEdit.getQuestions())) };

        formReq_params.push(["data", JSON.stringify(payload)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                // onreadystatechange fires for every readyState transition; only act on completion.
                if (req.request.readyState != 4) {
                    return;
                }

                let responseParsed: any = {};
                try {
                    responseParsed = JSON.parse(req.request.response || '{}');
                } catch (e) {
                }

                if (req.request.status == 200) {
                    let questions = responseParsed && responseParsed.data ? responseParsed.data.questions : null;
                    if (questions) {
                        obj.pollsEdit.setQuestions(questions);
                    }

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Commercial signals generated. Click Save to persist your changes.');
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    let message = responseParsed && responseParsed.message
                        ? responseParsed.message
                        : 'Unable to generate commercial signals.';

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, message);
                    obj.getVnAppZone().showNotificationToModule();
                }

                obj.pollsEdit.setIsGeneratingCommercialSignals(false);
                obj.loadingOut(obj.pollsEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected cancel(id) {
        //release lock
        let brandId = this.getBrandId();

        this.releaseLock(id, brandId);
        page.redirect(`/brand/${brandId}/categorization/polls/`);
    }

    protected releaseLock(id, brandId) {
        // request a lock release
        let usrReq_url: string = `/api/brand/${brandId}/polls/release/${id}`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }


    public addQuestionToList(question) {
        this.pollsEdit.addQuestionToList(question);
    }

    public updateEditedQuestionInList(question) {
        this.pollsEdit.updateEditedQuestionInList(question);
    }

    public cancelEditedQuestionInList(question) {
        this.pollsEdit.cancelEditedQuestionInList(question);
    }

    protected setReferences(references) {
        this.pollsEdit.setReferences(references);
    }

    public filterMultipleSelectorOnChange(idElement) {
        console.log('poll_edit_filterMultipleSelectorOnChange', idElement);
    }

    protected getArticlesSuggestion(keyword, idElement) {
        const params = [["data", ko.toJSON({list: {keyword, sourceId: idElement}})]];
        const request = new XMLHttpRequestHandler(`/api/brand/${this.getBrandId()}/polls/article-suggestions/`, params, this);
        request.onReadyStateFunction = (req, obj) => () => obj.manageResponse(req, obj, () => {
            const articles = JSON.parse(req.request.response).data.articles;
            if (idElement === 'discussionArticle') {
                obj.pollsEdit.setDiscussionArticleOptions(articles);
                return;
            }

            obj.pollsEdit.setArticleOptions(articles);
        });
        request.execute();
    }

    protected filterSimpleOnChange(idElement) { }

    protected generateBasedOnArticle() {
        const articleId = this.pollsEdit.getReferenceArticleId();
        if (!articleId) return;
        this.loadingIn(this.pollsEdit.builtTemplate);
        const payload = {
            idPoll: this.pollsEdit.getId(),
            idReferenceArticle: articleId,
            idReferenceBrand: this.pollsEdit.getReferenceBrandId(),
        };
        const request = new XMLHttpRequestHandler(`/api/brand/${this.getBrandId()}/polls/generate-from-article/`, [["data", ko.toJSON(payload)]], this);
        request.mode = XMLHttpRequestHandler_requestType.POST;
        request.onReadyStateFunction = (req: any, obj: any) => () => {
            if (req.request.readyState != 4) {
                return;
            }

            if (req.request.status < 200 || req.request.status >= 300) {
                let message = 'Poll generation failed. Please try again.';
                try {
                    const responseParsed = JSON.parse(req.request.response || '{}');
                    message = responseParsed.message || responseParsed.error || message;
                } catch (e) {}
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, message);
                obj.getVnAppZone().showNotificationToModule();
                obj.loadingOut(obj.pollsEdit.builtTemplate);
                return;
            }

            let didGenerate = false;
            try {
                obj.manageResponse(req, obj, () => {
                    const responseData = JSON.parse(req.request.response).data;
                    obj.pollsEdit.setName(responseData.name);
                    obj.pollsEdit.setGeneratedQuestions(responseData.questions);
                    obj.pollsEdit.setReferenceBrandId(responseData.idReferenceBrand);
                    obj.pollsEdit.setReferenceArticle(responseData.referenceArticle);
                    obj.pollsEdit.lockReferenceArticle(responseData.dateGeneratedFromArticle);
                    obj.pollsEdit.setReferenceArticle(responseData.referenceArticle);
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Poll generated from article.');
                    didGenerate = true;
                });
            } finally {
                obj.loadingOut(obj.pollsEdit.builtTemplate);
            }
            if (didGenerate) {
                obj.savePoll(false);
            }
        };
        request.execute();
    }

}



// WEBPACK FOOTER //
// ./js/modules/polls_edit.ts